import Upload from "@/modules/Upload";

export default {
    name: 'OlUpload',
    props: {
        title: {
            type: String,
            default: ''
        },
        size: {
            type: String,
            default: 'small'
        },
        type: {
            type: String,
            default: 'primary'
        },
        value: {
            type: Array,
            default() { return [] }
        }
    },
    data() {
        return {
            fileList: [],
        };
    },
    methods: {
        // 用于初始化一些数据
        init() { },
        // 用于更新一些数据
        update() { },
        beforeUpload(file) {
            new Upload()
                .file(file)
                .suffix(Upload.getSuffix(file.name))
                .send((url) => {
                    this.fileList.push({ name: file.name, url: this.$getUrl(url), PicUrl: url, FileName: file.name });
                    this.upInput();
                }, (e) => {
                    this.$error('上传失败~');
                })
            return false;
        }, 
        beonpreview(file) {

        },
        upInput() {
            this.$emit('input', this.fileList);
            this.$emit('on-success', this.fileList);
        },
        onRemove(f, fl) {
            this.fileList = fl;
            this.upInput();
        }
    },
    // 计算属性
    computed: {},
    // 包含 Vue 实例可用过滤器的哈希表。
    filters: {},
    // 在实例创建完成后被立即调用
    created() { },
    // 在挂载开始之前被调用：相关的 render 函数首次被调用。
    beforeMount() { },
    // el 被新创建的 vm.el 替换，并挂载到实例上去之后调用该钩子。
    mounted() {
        this.$nextTick(() => {
            this.value.forEach(el => {
                el.name = el.FileName;
                el.url = this.$getUrl(el.PicUrl);
            });
            this.fileList = this.value;
        });
    },
    // 数据更新时调用，发生在虚拟 DOM 打补丁之前。
    beforeUpdate() { },
    // keep-alive 组件激活时调用。
    activated() { },
    // keep-alive 组件停用时调用。
    deactivated() { },
    // 实例销毁之前调用。在这一步，实例仍然完全可用。
    beforeDestroy() { },
    //Vue 实例销毁后调用。
    destroyed() { },
    // 当捕获一个来自子孙组件的错误时被调用。
    errorCaptured() { },
    // 包含 Vue 实例可用指令的哈希表。
    directives: {},
    // 一个对象，键是需要观察的表达式，值是对应回调函数。
    watch: {
        value() {
            this.value.forEach(el => {
                el.name = el.FileName;
                el.url = this.$getUrl(el.PicUrl);
            });
            this.fileList = this.value;
        }
    },
    // 组件列表
    components: {},
};